import type { PropsWithChildren } from 'react';
import { useCallback } from 'react';
import { useIsIntegrationClient } from '@frameio/shared/contexts/ClientNameContext';
import { useOpenInBrowserMutation } from '@frameio/shared/integrations/gql';
import { getV4AppServerOriginFromIntegrations } from '@frameio/shared/routing/redirectToV4';
import { StyledLink } from './StyledLink';

export function UniversalLink({
  children,
  href,
  ...rest
}: PropsWithChildren<{
  href: string;
  target?: string;
}>) {
  const [openInBrowser] = useOpenInBrowserMutation({
    context: { resolveWithUXP: true },
  });
  const isIntegrationClient = useIsIntegrationClient();
  const onClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      const integrationsUrl = href.startsWith('/')
        ? new URL(href, getV4AppServerOriginFromIntegrations()).href
        : href;
      if (isIntegrationClient) {
        e.preventDefault();
        openInBrowser({
          variables: {
            input: {
              url: integrationsUrl,
            },
          },
        });
      }
    },
    [isIntegrationClient, href, openInBrowser]
  );

  return (
    <StyledLink href={href} {...rest} onClick={onClick}>
      {children}
    </StyledLink>
  );
}
